import { Component, HostListener } from '@angular/core';
import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';
import { OwlOptions } from 'ngx-owl-carousel-o';

export interface Work {
  img: string;
  title: string;
  category: string;
}

@Component({
  selector: 'app-home-two',
  templateUrl: './home-two.component.html',
  styleUrl: './home-two.component.css'
})
export class HomeTwoComponent {
  //header
  lastScrollTop = 0;
  isHidden = false;
  isMenuOpen = false;
  activeDropdown: number | null = null;

  // Gallery Properties
  currentGalleryIndex = 0;
  showGalleryModal = false;

  // Gallery Items
  galleryItems = [
    {
      src: 'assets/images/portfolio/gallery-14.jpg',
      title: 'Gallery Image 1'
    },
    {
      src: 'assets/images/portfolio/gallery-15.jpg',
      title: 'Gallery Image 2'
    },
    {
      src: 'assets/images/portfolio/gallery-16.jpg',
      title: 'Gallery Image 3'
    },
    {
      src: 'assets/images/portfolio/gallery-17.jpg',
      title: 'Gallery Image 4'
    },
    {
      src: 'assets/images/portfolio/gallery-18.jpg',
      title: 'Gallery Image 5'
    },
    {
      src: 'assets/images/portfolio/gallery-19.jpg',
      title: 'Gallery Image 6'
    }
  ];

  // About Gallery Properties
  currentAboutGalleryIndex = 0;
  showAboutGalleryModal = false;

  // About Gallery Items
  aboutGalleryItems = [
    {
      src: 'assets/images/about/about-img-3.jpg',
      title: 'Gallery Image 1'
    },
    {
      src: 'assets/images/about/about-img-4.jpg',
      title: 'Gallery Image 2'
    }
  ];

  // Pricing Plans
  pricingPlans = [
    {
      id: 1,
      name: 'Basic Plan',
      price: '$29.99',
      features: [
        'Up to 5 Projects',
        '5GB Storage',
        'Basic Support',
        'Monthly Updates',
        'Community Access'
      ]
    },
    {
      id: 2,
      name: 'Professional',
      price: '$79.99',
      features: [
        'Unlimited Projects',
        '500GB Storage',
        'Priority Support',
        'Weekly Updates',
        'Advanced Analytics',
        'Team Collaboration'
      ]
    },
    {
      id: 3,
      name: 'Enterprise',
      price: '$199.99',
      features: [
        'Custom Solutions',
        'Unlimited Storage',
        '24/7 Support',
        'Real-time Updates',
        'Advanced Analytics',
        'Custom Integration',
        'Dedicated Account Manager'
      ]
    }
  ];

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  toggleDropdown(index: number): void {
    this.activeDropdown = this.activeDropdown === index ? null : index;
  }

  closeMenu() {
    this.isMenuOpen = false;
    this.activeDropdown = null;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.nav-item') && !target.closest('.header-toggle')) {
      this.activeDropdown = null;
    }
  }

  @HostListener('window:scroll', [])
  onScroll(): void {

    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    // Check scroll direction
    if (currentScroll > this.lastScrollTop && currentScroll > 100) {
      // Scrolling down
      this.isHidden = true;
    } else {
      // Scrolling up
      this.isHidden = false;
    }

    this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; 
  }

  // Social Links
  socialLinks = [
    { icon: 'bi-facebook', class: 'button-circle-social-facebook', url: '#' },
    { icon: 'bi-twitter-x', class: 'button-circle-social-twitter', url: '#' },
    { icon: 'bi-pinterest', class: 'button-circle-social-pinterest', url: '#' },
    { icon: 'bi-instagram', class: 'button-circle-social-instagram', url: '#' }
  ];

  //Features
  features = [
    {
      icon: 'bi bi-palette',
      title: 'Mobile App Design',
      description: 'Not just design - we create emotional, memorable experiences that convert.'
    },
    {
      icon: 'bi bi-lightbulb',
      title: 'Web Design',
      description: 'Design without purpose is decoration. We blend creativity with business goals.'
    },
    {
      icon: 'bi bi-magic',
      title: 'UI/UX Design',
      description: 'A creative team obsessed with pushing pixels, solving problems, creating digital.'
    }
  ];

  
  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  //Works
  works: Work[] = [
    {
      img:'gallery-1.jpg',
      title:'Digital Food',
      category:'Branding'
    },
    {
      img:'gallery-3.jpg',
      title:'Poster',
      category:'Branding'
    },
    {
      img:'gallery-4.jpg',
      title:'Blue Berry',
      category:'Branding'
    },
    {
      img:'gallery-11.jpg',
      title:'Death Proof',
      category:'UI/UX Design'
    },
    {
      img:'gallery-12.jpg',
      title:'3d Design',
      category:'Media'
    },
    {
      img:'gallery-13.jpg',
      title:'Muse + Metta',
      category:'Development'
    }
  ];

  openGallery(index: number): void {
    this.currentGalleryIndex = index;
    this.showGalleryModal = true;
  }

  closeGallery(): void {
    this.showGalleryModal = false;
  }

  nextGalleryImage(): void {
    if (this.currentGalleryIndex < this.galleryItems.length - 1) {
      this.currentGalleryIndex++;
    } else {
      this.currentGalleryIndex = 0;
    }
  }

  previousGalleryImage(): void {
    if (this.currentGalleryIndex > 0) {
      this.currentGalleryIndex--;
    } else {
      this.currentGalleryIndex = this.galleryItems.length - 1;
    }
  }

  // About Gallery Methods
  openAboutGallery(index: number): void {
    this.currentAboutGalleryIndex = index;
    this.showAboutGalleryModal = true;
  }

  closeAboutGallery(): void {
    this.showAboutGalleryModal = false;
  }

  nextAboutGalleryImage(): void {
    if (this.currentAboutGalleryIndex < this.aboutGalleryItems.length - 1) {
      this.currentAboutGalleryIndex++;
    } else {
      this.currentAboutGalleryIndex = 0;
    }
  }

  previousAboutGalleryImage(): void {
    if (this.currentAboutGalleryIndex > 0) {
      this.currentAboutGalleryIndex--;
    } else {
      this.currentAboutGalleryIndex = this.aboutGalleryItems.length - 1;
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.closeGallery();
    this.closeAboutGallery();
  }

  // Brand Carousel
  brandsCarousel: OwlOptions = {
    loop: true,
    dots: false,
    margin:50,
    nav:true,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 5,
    navText: ['<i class="bi bi-arrow-left-short"></i>', '<i class="bi bi-arrow-right-short"></i>'],
  }

  brandStore = [
    {img: "brand-1-white.png"},
    {img: "brand-2-white.png"},
    {img: "brand-3-white.png"},
    {img: "brand-4-white.png"},
    {img: "brand-5-white.png"},
    {img: "brand-6-white.png"}
  ];

  // OWl Slider
  customOptions: OwlOptions = {
    loop: true,
    dots: true,
    margin:30,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 1,
    navText: ['<i class="bi bi-arrow-left"></i>', '<i class="bi bi-arrow-right"></i>'],
  }

  slideStore = [
    {
      title: "Anny Adams",
      subtitle: "CEO/Founder",
      image: "client-1-md.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      title: "Bryan Matt",
      subtitle: "Developer",
      image: "client-2-md.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      title: "David Marks",
      subtitle: "Designer",
      image: "client-3-md.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    }

  ];

  // Contact Form
  formData = {
    user_name: '',
    user_email: '',
    message: ''
  };

  // EmailJS service configuration
  private serviceId = 'helifax-form';  // Replace with your EmailJS Service ID
  private templateId = 'helifax-form';  // Replace with your EmailJS Template ID
  private publicKey = 'dOfh1ImCGDZCO9GJb';  // Replace with your EmailJS Public Key

  // Method to send email on form submission
  public sendEmail(event: Event): void {
    event.preventDefault();

    // Send email using EmailJS
    emailjs.sendForm(this.serviceId, this.templateId, event.target as HTMLFormElement, this.publicKey)
      .then(
        (response: EmailJSResponseStatus) => {
          alert('Message sent successfully. Thank you, we will get back to you soon!');
          this.resetForm();
        },
        (error: EmailJSResponseStatus) => {
          console.error('Failed to send message. Error:', error.text);
          alert('Failed to send the message. Please try again later.');
        }
      );
  }

  // Method to reset the form after submission
  private resetForm(): void {
    this.formData = {
      user_name: '',
      user_email: '',
      message: ''
    };
  }

  socialIcons = [
    { name: 'facebook', icon: 'facebook' },
    { name: 'twitter', icon: 'twitter-x' },
    { name: 'pinterest', icon: 'pinterest' },
    { name: 'instagram', icon: 'instagram' }
  ];

  //Footer
  year = new Date().getFullYear();

  footerLinks = [
    { label: 'About Me', url: '/about' },
    { label: 'Contact Me', url: '/contact' },
    { label: 'Work', url: '/work' }
  ];

  socialLinksFooter = [
    { icon: 'bi bi-facebook', url: 'https://facebook.com' },
    { icon: 'bi bi-twitter-x', url: 'https://twitter.com' },
    { icon: 'bi bi-linkedin', url: 'https://linkedin.com' },
    { icon: 'bi bi-behance', url: 'https://behance.net' }
  ];
}
